export default (name) => {
  const env = process.env[`VUE_APP_${name.toUpperCase()}`];
  if (!!env) {
    return env;
  }
  return false;
};
